module.exports = __webpack_public_path__ + "img/clock.4aea91f4.png";